import { themeColours } from "../../resources";
import "./HomePageGuide.css";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { InfoModal } from "./InfoModal";
import { useStateObject } from "../../hooks/useStateObject";
import { useNavigate } from "react-router-dom";
const resultPage = require("../../assets/resultPage.png");

export function ResultPageGuide() {
  const [iconChecks, setIconChecks] = useStateObject<{ [key: string]: boolean }>({});
  const navigate = useNavigate()
  function handleShopClick() {
    localStorage.setItem("cartCheck", "T")
    return navigate("/guide/cart")
  }
  return (
    <div className="homePageContainer">
      <img src={resultPage} alt="background" className="background" />
      <InfoModal
        element={
          <span className="valueIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["value"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Value Items"}
        texts={[
          <h5 className="modalInfo">
            The value pill indicates the product with the best value{" "}
            <strong className="extraBold">(volume adjusted price)</strong> that meets all the search criteria. Results
            are ordered in <strong className="extraBold">decreasing</strong> order of value.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ value: true })}
      />
      <InfoModal
        element={
          <span className="promIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["prom"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Promotional Items"}
        texts={[
          <h5 className="modalInfo">
            There is currently a promotion for this item and the <strong className="extraBold">sale price</strong> is
            being used.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ prom: true })}
      />
      <InfoModal
        element={
          <span className="valueNumIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["valueNum"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Item Value"}
        texts={[
          <h5 className="modalInfo">
            The item's current value. The % represents how the value for that item compares to the{" "}
            <strong className="extraBold">average value</strong> for all items that meet the search criteria.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ valueNum: true })}
      />
      <InfoModal
        element={
          <span className="bellIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["bell"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Flag Item"}
        texts={[
          <h5 className="modalInfo">
            Flag this item for being in the <strong className="extraBold">wrong place</strong> or having{" "}
            <strong className="extraBold">incorrect</strong> information. We will fix it - thanks!
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ bell: true })}
      />
      <InfoModal
        element={
          <span className="healthIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["health"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"HF/HC Item"}
        texts={[
          <h5 className="modalInfo">
            The item is a <strong className="extraBold">Vitality HealthyFood or HealthCare</strong> item.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ health: true })}
      />
      <InfoModal
        element={
          <span className="specSearchIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["specSearch"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Item Search"}
        texts={[
          <h5 className="modalInfo">
            Narrow your search to only consider this <strong className="extraBold">specific</strong> item across your
            selected stores (same as searching by title).
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ specSearch: true })}
      />
      <InfoModal
        element={
          <span className="quantityIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["quantity"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Item Quantity"}
        texts={[
          <h5 className="modalInfo">
            The quantity of items required to meet the <strong className="extraBold">volume</strong> criteria and get
            the <strong className="extraBold">best value</strong>.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ quantity: true })}
      />
      <InfoModal
        element={
          <span className="cartIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={localStorage.getItem("cartCheck") === "T" ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Shop Cart"}
        texts={[
          <h5 className="modalInfo">
            This holds all the items that have been <strong className="extraBold">added</strong> to your cart from your
            current shop, as well as <strong className="extraBold">insightful</strong> information regarding your
            selections.
          </h5>,
        ]}
        onOpenClick={() => {}}
        buttonText="Learn more"
        onButtonClick={handleShopClick}
      />
    </div>
  );
}
